import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=da3de768&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=da3de768&prod&lang=scss&scoped=true"
import style1 from "./Details.vue?vue&type=style&index=1&id=da3de768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3de768",
  null
  
)

export default component.exports